<template>
  <section id="dash-profit" class="flex column">
    <!-- filters -->
    <div class="flex-1 w100">
      <div class="flex row middle">
        <div class="flex-1 w100">
          <div class="flex end filters-group-holder row">
            <div v-if="false" class="filter-item">
              <label>Moeda</label>
              <select class="input" v-model="filters.data.currency">
                <option
                  v-for="(c, index) in filters.list.listCurrency"
                  :key="index"
                  :value="c.value"
                  :selected="c.value === filters.data.currency"
                >
                  {{ c.label }}
                </option>
              </select>
            </div>

              <div style="margin-right: 8px;" class="flex column no-mobile">
              <label>Editar</label>
              <div class="flex end w100" style="margin-top:12px">
              <router-link v-if="checkResource('profit')" :to="{ name: 'DashEdit', params: {dash_id: dash.id } }">
                  <div class="button secondary">
                    <i class="fas fa-edit"></i>
                  </div>
              </router-link>
              
              </div>
            </div>

            <div style="margin-right: 16px;" class="flex column no-mobile">
              <label>Atualizar</label>
              <div class="flex end w100" style="margin-top:12px">
                <div @click="forceRefreshData()" class="button secondary">
                  <i class="fas fa-sync-alt"></i>
                </div>
              </div>
            </div>

            <div style="margin-right: 16px;" class="flex column no-mobile">
              <label>TV</label>
              <div class="flex end w100" style="margin-top:12px">
                <div
                  @click="fullScreenDash('dash-profit')"
                  class="button secondary"
                >
                  <i class="fas fa-tv"></i>
                </div>
              </div>
            </div>

            <div class="filter-item w100">
              <label>Conta de Anúncio</label>
              <select class="input" v-model="filters.data.accountAds">
                <option v-for="(c, index) in filters.list.listAccountAds" :key="index" :value="c.value" :selected="c.value === filters.data.accountAds">
                  {{ c.label }}
                </option>
              </select>
            </div>

            <div class="filter-item w100">
              <label>Fonte dos Leads</label>
              <select class="input" v-model="filters.data.sourceLead">
                <option
                  v-for="(c, index) in filters.list.listSourceLead"
                  :key="index"
                  :value="c.value"
                  :selected="c.value === filters.data.sourceLead"
                >
                  {{ c.label }}
                </option>
              </select>
            </div>

            <ltk-date-picker
              label="Filtro de data"
              v-model="filters.data.date"
              :loading="loading"
            ></ltk-date-picker>
          </div>
        </div>
      </div>
    </div>

    <!-- big card -->
    <div class="flex-1 w100 margin-top-l">
      <div class="grid-flex wrap">
        <div class="item flex-1 center-txt">
          <div class="box primary-bg">
            <div class="box-content custom-card w100">
              <div class="flex row middle">
                <div class="flex-2">
                  <h1 class="margin-top-s">
                    <AnimatedNumber
                      :value="stats.cost_lead"
                      :formatValue="$filters.money"
                      :duration="2000"
                      :round="true"
                      :delay="0"
                      easing="easeOutQuart"
                    />
                  </h1>
                  <span>Custo por Lead</span>
                </div>
                <div class="flex-1 source-data">
                  <div>
                    <h3 class="">
                      <i class="fab fa-facebook"></i> 
                      <AnimatedNumber
                        :value="stats.fbads_cost_lead"
                        :formatValue="$filters.money"
                        :duration="2000"
                        :round="true"
                        :delay="0"
                        easing="easeOutQuart"
                      />
                    </h3>
                  </div>
                  <div>
                    <h3 class="margin-top-s">
                      <i class="fab fa-google"></i> 
                      <AnimatedNumber
                        :value="stats.gads_cost_lead"
                        :formatValue="$filters.money"
                        :duration="2000"
                        :round="true"
                        :delay="0"
                        easing="easeOutQuart"
                      />
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="item flex-1 center-txt">
          <div class="box">
            <div class="box-content custom-card w100">
              <div class="flex row middle">
                <div class="flex-2">
                  <h1 class="margin-top-s">
                    <AnimatedNumber
                        :value="stats.leads"
                        :formatValue="$filters.number"
                        :duration="2000"
                        :round="true"
                        :delay="0"
                        easing="easeOutQuart"
                      />
                  </h1>
                  Leads Captados (Total)
                </div>
                <div class="flex-1 source-data">
                  <div>
                    <h3 class="">
                      <i class="fab fa-facebook"></i> 
                      <AnimatedNumber
                        :value="stats.fbads_leads"
                        :formatValue="$filters.number"
                        :duration="2000"
                        :round="true"
                        :delay="0"
                        easing="easeOutQuart"
                      />
                    </h3>
                  </div>
                  <div>
                    <h3 class="margin-top-s">
                      <i class="fab fa-google"></i>
                      <AnimatedNumber
                        :value="stats.gads_leads"
                        :formatValue="$filters.number"
                        :duration="2000"
                        :round="true"
                        :delay="0"
                        easing="easeOutQuart"
                      />
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- cards -->
    <div class="flex-1 w100">
      <!-- cards -->
      <div class="flex-1 w100">
        <div class="grid-flex wrap">
          <div class="item flex-1">
            <box-info
              icon="fas fa-eye"
              bigIcon="True"
              label="Visualizações das Páginas"
              tooltip="Somatório de custos de campanhas ATIVAS FACEBOOK ADS"
              :value="stats.pageview"
              :money="false"
              :currency="filters.data.currency"
            >
            </box-info>
          </div>
          <div class="item flex-1">
            <box-info
              icon="fas fa-percentage"
              bigIcon="True"
              label="Tax. Conversão"
              tooltip="Somatório de custos de campanhas ATIVAS FACEBOOK ADS"
              :value="stats.conversion"
              :money="false"
              :currency="filters.data.currency"
              suffix="%"
            >
            </box-info>
          </div>
        </div>
      </div>
      <!-- cards -->
      <div class="flex-1 w100">
        <div class="grid-flex wrap">
          <div class="item flex-1">
            <box-info
              icon="fab fa-facebook"
              bigIcon="True"
              label="Custo de Marketing FBADS"
              tooltip="Somatório de custos de campanhas ATIVAS FACEBOOK ADS"
              :value="stats.fbads_cost_marketing"
              :money="true"
              :currency="filters.data.currency"
            >
            </box-info>
          </div>

          <div class="item flex-1">
            <box-info
              icon="fab fa-google"
              bigIcon="True"
              label="Custo de Marketing GADS"
              tooltip="Somatório de custos de campanhas ATIVAS GOOGLE ADS"
              :value="stats.gads_cost_marketing"
              :money="true"
              :currency="filters.data.currency"
            >
            </box-info>
          </div>

          <div class="grid-flex wrap w100">
            <div class="item flex-1 center-txt">
              <div class="box2  ">
                <div class="box-content2 custom-card">
                  <div class="flex row">
                    <custom-line
                      class="margin-top-l w100"
                      :data="chartDataPolarMKT.data"
                      :colors="colorsMKT"
                    ></custom-line>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    <!-- group by sale -->
    <div class="box flex-1 w100 margin-top-l  no-mobile">
      <div class="flex box-title middle">
        <div class="flex-1">
          <h4>
            Explorador de Origens
          </h4>
        </div>
        <div class="flex end filters-group-holder">
          <div class="filter-item">
            <label>Buscar</label>
            <div class="flex w100">
              <input class="input" type="text" v-model="filters.data.search" />
            </div>
          </div>
          <div class="filter-item">
            <label>Agrupar por</label>
            <select class="input" v-model="filters.data.group_by">
              <option
                v-for="(c, index) in filters.list.group_by"
                :key="index"
                :value="c.value"
                :selected="c.value === filters.data.group_by"
              >
                {{ c.label }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="box-content max-table">
        <ul>
          <li class="header">
            <div class="flex middle row">
              <div class="flex-1">
                <div class="flex middle row">
                  <div class="flex-1 name">
                    <b>{{ filters.data.group_by }}</b>
                  </div>
                  <div class="flex-1">
                    <div class="flex details between">
                      <div class="flex-1 txt-center">
                        <p><b>Visitas</b></p>
                      </div>
                      <div class="flex-1 txt-center">
                        <p><b>Leads</b></p>
                      </div>
                      <div class="flex-1 txt-center">
                        <p><b>Conversão</b></p>
                      </div>
                      <div class="flex-1 txt-center">
                        <p><b>Custo do Lead</b></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li v-for="(track, index) in trackings" :key="index">
            <div class="flex middle row">
              <div class="flex-3">
                <div class="flex middle row">
                  <div class="flex-1 name margin-top-s">
                    <p>
                      {{ track.name | protect }}
                    </p>
                  </div>
                  <div class="flex-1 margin-top-s">
                    <div class="flex details between">
                      <div class="flex-1 txt-center">
                        {{ track.stats.pageview | number }}
                      </div>
                      <div class="flex-1 txt-center">
                        {{ track.stats.leads | number }}
                      </div>
                      <div class="flex-1 txt-center">
                        {{ track.stats.conv }}%
                      </div>
                      <div class="flex-1 txt-center">
                        {{ track.stats.cost_lead | money }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>

        <div v-if="isEmpty" class="center-text">
          <div class="margin-top-l">
            <p>
              Não encontramos nenhuma origem de venda. Assim que você tiver a
              primeira venda a origem vai aparecer nessa lista de forma
              automática!
            </p>
          </div>
        </div>

        <div v-if="loading">
          <content-loading>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
          </content-loading>
        </div>

        <!-- pagination -->
        <div class="flex-1 flex row w100 middle margin-top-l">
          <div class="flex w100 center filters-groupo-holder">
            <div class="flex between middle">
              <paginate
                :containerClass="'pagination'"
                :page-count="totalPages"
                v-model="page"
                :page-range="5"
                :click-handler="clickCallback"
                :prev-text="'Anterior'"
                :next-text="'Próxima'"
              ></paginate>
            </div>
          </div>
        </div>
      </div>
    </div>

      <div class="flex-1 margin-top-l no-mobile">
        <div class="">
          <h3>Detalhamento por Dia</h3>
        </div>
      </div>
      <div class="flex-1 w100 margin-top-l  no-mobile">
        <div class="flex">
          <tabs :data="reportTabs" v-model="currentTab"></tabs>
        </div>
      </div>
      <div v-if="currentTab === 'table'" class="flex-1 no-mobile">
        <div class="box margin-top-l">
          <div class="box-content  max-table">
            <ul>
              <li class="header">
                <div class="flex middle row">
                  <div class="flex-1">
                    <div class="flex middle row">
                      <div class="flex-1">
                        <div class="flex details between">
                          <div class="flex-1 txt-center">
                            <p><b>Data</b></p>
                          </div>
                          <div class="flex-1 txt-center">
                            <p><b>Leads</b></p>
                          </div>
                          <div class="flex-1 txt-center">
                            <p><b>Custo do Lead</b></p>
                          </div>
                          <div class="flex-1 txt-center">
                            <p><b>Conversão</b></p>
                          </div>
                          <div class="flex-1 txt-center">
                            <p><b>Visualizações</b></p>
                          </div>
                          <div class="flex-1 txt-center">
                            <p><b>Marketing</b></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li v-for="(t, index) in auxTable" :key="index">
                <div class="flex middle row">
                  <div class="flex-3">
                    <div class="flex middle row">
                      <div class="flex-1 margin-top-s">
                        <div class="flex details between">
                          <div class="flex-1 txt-center">
                            {{ t.date }}
                          </div>
                          <div class="flex-1 txt-center">
                            <b>{{ t.stats.leads | number }}</b>
                          </div>
                          <div class="flex-1 txt-center">
                            <b>{{ t.stats.cost_lead | money }}</b>
                          </div>
                          <div class="flex-1 txt-center" :class="{ red: t.stats.conversion < 15, gren: t.stats.conversion > 30}">
                            <b>{{ t.stats.conversion | number }}%</b>
                          </div>
                          <div class="flex-1 txt-center">
                            <b>{{ t.stats.pageview | number }}</b>
                          </div>
                          <div class="flex-1 txt-center">
                            {{ t.stats.cost_marketing | money }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li class="margin-top-m">
                <div class="flex middle row">
                  <div class="flex-3">
                    <div class="flex middle row">
                      <div class="flex-1 margin-top-s">
                        <div class="flex details between">
                          <div class="flex-1 txt-center">
                            <b>Total</b>
                          </div>
                          <div class="flex-1 txt-center">
                            <b>{{ sum(auxTable, 'leads') | number }}</b>
                          </div>
                          <div class="flex-1 txt-center">
                            <b>{{ avg(auxTable, 'cost_lead') | money }}</b>
                          </div>
                          <div class="flex-1 txt-center">
                            <b>{{ avg(auxTable, 'conversion') | number }}%</b>
                          </div>
                          <div class="flex-1 txt-center">
                            <b>{{ sum(auxTable, 'pageview') | number }}</b>
                          </div>
                          <div class="flex-1 txt-center">
                            <b>{{ sum(auxTable, 'cost_marketing') | money }}</b>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>

          </div>
        </div>
      </div>
      <!-- graph days -->
      <div v-if="currentTab === 'graph'" class="flex-1 no-mobile">
        <div class="box margin-top-l">
          <div class="box-content">
            <bar-chart
              v-if="
                chartDataLine.data.datasets &&
                  chartDataLine.data.datasets.length > 0
              "
              class="margin-top-l"
              :height="140"
              :chartData="chartDataLine.data"
              :options="chartDataLine.options"
              :limit="30"
              color="green"
            ></bar-chart>
          </div>
        </div>
      </div>

      <div class="flex-1 margin-top-l no-mobile">
        <div class="">
          <h3>Detalhamento por Hora</h3>
        </div>
      </div>

      <div class="flex-1 w100 margin-top-l  no-mobile">
        <div class="flex">
          <tabs :data="reportTabs" v-model="currentTabHours"></tabs>
        </div>
      </div>
      <div v-if="currentTabHours === 'table'" class="flex-1 no-mobile">
        <div class="box margin-top-l">
          <div class="box-content max-table">
            <ul>
              <li class="header">
                <div class="flex middle row">
                  <div class="flex-1">
                    <div class="flex middle row">
                      <div class="flex-1">
                        <div class="flex details between">
                          <div class="flex-1 txt-center">
                            <p><b>Hora</b></p>
                          </div>
                          <div class="flex-1 txt-center">
                            <p><b>Leads</b></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li v-for="(t, index) in auxTableHours" :key="index">
                <div class="flex middle row">
                  <div class="flex-3">
                    <div class="flex middle row">
                      <div class="flex-1 margin-top-s">
                        <div class="flex details between">
                          <div class="flex-1 txt-center">
                            <b>{{ t.date }}</b>
                          </div>
                          <div class="flex-1 txt-center">
                            <b v-if="t.stats.lead > 0">{{ t.stats.lead | number }}</b>
                            <b v-else> - </b>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li class="margin-top-m">
                <div class="flex middle row">
                  <div class="flex-3">
                    <div class="flex middle row">
                      <div class="flex-1 margin-top-s">
                        <div class="flex details between">
                          <div class="flex-1 txt-center">
                            <b>Total</b>
                          </div>
                          <div class="flex-1 txt-center">
                            <b>{{ sum(auxTableHours, 'lead') | number }}</b>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>

          </div>
        </div>
      </div>
      <!-- graph days -->
      <div v-if="currentTabHours === 'graph'" class="flex-1 no-mobile">
        <div class="box margin-top-l">
          <div class="box-content">
            <bar-chart
              v-if="
                chartDataHour.data.datasets &&
                  chartDataHour.data.datasets.length > 0
              "
              class="margin-top-l"
              :height="140"
              :chartData="chartDataHour.data"
              :options="chartDataHour.options"
              :limit="30"
              color="green"
            ></bar-chart>
          </div>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import { getLeadsReport } from "@/services/lead";
import { getTrackingsLead } from "@/services/tracking.js";

import { getFilters } from "@/services/filters";

import barChart from "@/components/charts/barChart";
import boxInfo from "@/components/boxInfo/BoxInfo";
import ltkDatePicker from "@/components/datepicker/LtkDatePicker";
import customLine from "./customLine";
import Tabs from "@/components/tabs/Tabs";

import moment from "moment";
moment.locale("pt-br");

import { mapState } from "vuex";

const emptyData = {
  profit: "-",
  sales: "-",
  receita_bruta: "-",
  receita_liquida: "-",
  cost_product: "-",
  gads_cost_marketing: "-",
  fbads_cost_marketing: "-",
  cost_marketing: "-",
  cost_tax: "-",
  cost_impost: "-",
  conv_billet: "-",
  avg_ticket: "-",
  percent_profit: "-",
  cpa: "-",
  fbads_cpa: "-",
  gads_cpa: "-",
  roi: "-",
  approved_sales_count: "-",
  approved_sales_sum: "-",
  await_payment_sales_count: "-",
  await_payment_sales_sum: "-",
  sum_commission_dollar: "-",
  sum_dollar: "-",
};

export default {
  name: "dash-lead",
  components: {
    barChart,
    customLine,
    ltkDatePicker,
    boxInfo,
    Tabs
  },
  props: ["dash"],
  data() {
    return {
      loading: false,
      isTvMode: false,
      stats: emptyData,
      refreshTime: 60, // 60s refresh data
      refreshInterval: null,
      currentTab: "table",
      currentTabHours: "table",
      UTMS: {
        utm_campaign: [],
        utm_medium: [],
        utm_source: [],
        utm_content: [],
        utm_term: [],
        src: [],
        sck: [],
      },
      offset: 10,
      page: 1,
      totalTracking: 0,
      trackings: [],
      reportTabs: [
        {
          name: "table",
          title: "Tabela",
        },
        {
          name: "graph",
          title: "Gráfico",
        },
      ],
      filters: {
        data: {
          date: [
            moment()
              .add(-0, "d")
              .startOf("day")
              .toDate(),
            moment()
              .startOf("day")
              .toDate(),
          ],
          currency: "BRL",
          sumCostsFixed: true,
          sourceLead: 'HOTTRACKER',
          accountAds: '',
          group_by: "utm_campaign",
          search: "",

        },
        list: {
          listCurrency: [
            {
              value: "BRL",
              label: "Real Brasileiro (BRL)",
            },
            {
              value: "USD",
              label: "Dólar Americano (USD)",
            },
          ],
          listSourceLead: [
            {
              value: "MARKETING",
              label: "Campanhas de Marketing",
            },
            {
              value: "HOTTRACKER",
              label: "Hot Tracker (Pixel)",
            },
            {
              value: "LEADLOVERS",
              label: "Lead Lovers",
            },
            {
              value: "ACTIVECAMPAIGN",
              label: "Active Campaign",
            },
            {
              value: "123MAIL",
              label: "123MAIL",
            },
            {
              value: "CUSTOM",
              label: "WEBHOOK PERSONALIZADO",
            },
            {
              value: "OTHERS",
              label: "Outros (API)",
            },
          ],
          listAccountAds: [],
          group_by: [
            {
              value: "campaign",
              label: "Campanhas",
            },
            {
              value: "adgroup",
              label: "Conjunto de Anúncios",
            },
            {
              value: "ad",
              label: "Anúncios",
            },
            {
              value: "utm_campaign",
              label: "utm_campaign",
            },
            {
              value: "utm_source",
              label: "utm_source",
            },
            {
              value: "utm_medium",
              label: "utm_medium",
            },
            {
              value: "utm_content",
              label: "utm_content",
            },
            {
              value: "utm_term",
              label: "utm_term",
            },
            {
              value: "sck",
              label: "sck",
            },
            {
              value: "src",
              label: "src",
            },
          ],
        },
      },
      chartDataLine: {
        options: {},
        data: {
          labels: [],
          datasets: [],
        },
      },
      chartDataHour: {
        options: {},
        data: {
          labels: [],
          datasets: [],
        },
      },
      chartDataPolar: {
        data: {
          Cartão: "-",
          Pix: "-",
          Boleto: "-",
        },
      },
      chartDataPolarMKT: {
        data: {
          FacebookAds: "-",
          GoogleAds: "-",
        },
      },
      colorsMKT: ["#3B5998", "#DB4437"],
    };
  },
  mounted() {
    if (this.dash) {
      this.initFilters()
    } else {
      this.getReport()
      this.getFilters()
    }

    this.refreshInterval = setInterval(this.getReport, this.refreshTime * 1000);
  },
  beforeDestroy() {
    clearInterval(this.refreshInterval);
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    totalPages() {
      let valueMode = this.totalTracking % this.offset;
      let value = this.totalTracking / this.offset;

      let pages = 1;

      if (valueMode == 0) {
        pages = value;
      } else {
        pages = parseInt(value) + 1;
      }

      return pages;
    },
    auxTable() {
      if (!this.chartDataLine.data.datasets && this.chartDataLine.data.datasets.length === 0) {
        return []
      }

      var newTable = []
      this.chartDataLine.data.labels.forEach((e, i) =>  {

        newTable.push({
          date: e,
          stats: {
            cost_lead: this.chartDataLine.data.datasets[0].data[i],
            leads: this.chartDataLine.data.datasets[1].data[i],
            pageview: this.chartDataLine.data.datasets[2].data[i],
            conversion: this.chartDataLine.data.datasets[3].data[i],
            cost_marketing: this.chartDataLine.data.datasets[4].data[i],
          }
        })
      })

      return newTable.reverse()
    }, 
    auxTableHours() {
      if (!this.chartDataHour.data.datasets && this.chartDataHour.data.datasets.length === 0) {
        return []
      }

      var newTable = []
      this.chartDataHour.data.labels.forEach((e, i) =>  {

        newTable.push({
          date: e,
          stats: {
            lead: this.chartDataHour.data.datasets[0].data[i],
          }
        })
      })

      return newTable
    }
  },
  watch: {
    "filters.data": {
      deep: true,
      handler() {
        this.stats = emptyData;
        this.getReport();
      },
    },
    page: {
      handler() {
        this.trackings = [];
        this.getTrackings();
      },
    },
  },
  methods: {
    initFilters() {
      let product = this.dash.custom_filters.product || ''
      let mktaccount = this.dash.custom_filters.mkt_account || ''
      let date = this.dash.custom_filters.date

      var _copyFilterData = Object.assign({}, this.filters.data)

      _copyFilterData.product = product 
      _copyFilterData.accountAds = mktaccount

      var _map_date = {
        'DAY': 0,
        'LAST7': -7,
        'LAST14': -14,
        'LAST30': -30,
        'LAST90': -90,
        'LASTMAX': -365,
      }

      var _code_day = _map_date[date] || 0
      var _init_day = 0 
      if (_code_day < 0) {
        _init_day = -1
        _code_day -= 1
      }
      let dateNew = [
            moment()
              .add(_code_day, "d")
              .startOf("day")
              .toDate(),
            moment()
              .add(_init_day, "d")
              .startOf("day")
              .toDate(),
      ]

      _copyFilterData.date = dateNew

      this.filters.data = _copyFilterData
      
    },
    sum(array, param) {
      if (param === undefined) {
        return array.reduce((total, e) => total + e, 0);
      }
      return array.reduce((total, e) => total + e.stats[param], 0);
    },
    avg(array, param) {
      return this.sum(array, param) / array.length;
    },
    forceRefreshData() {
      this.stats = emptyData;
      this.getReport();
    },
    getFilters() {
      getFilters()
        .then((result) => {
            this.filters.list.listAccountAds = result.accountAds
            // this.filters.list.listProduct = result.products
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu um problema'
          })
        })
    },
    fullScreenDash(elementId) {
      var elem = document.getElementById(elementId);

      // disable fullscreen
      if (this.isTvMode) {
        this.isTvMode = false;
        document.exitFullscreen();
        document.body.style.zoom = 1;

        return;
      }

      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari & Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        elem.msRequestFullscreen();
      }

      document.body.style.zoom = 0.8;

      this.isTvMode = true;
    },
    checkResource(name) {
      return this.account && this.account.resources.includes(name);
    },
    getReport() {
      if (this.loading) {
        return;
      }

      this.getTrackings()

      this.loading = true;

      const date = this.filters.data.date;
      let params = {
        start_date: date[0] ? date[0].toISOString().slice(0, 10) : "",
        end_date: date[1] ? date[1].toISOString().slice(0, 10) : "",
        currency: this.filters.data.currency,
        sum_costs_fixed: this.filters.data.sumCostsFixed,
        source_lead: this.filters.data.sourceLead,
        account_ads: this.filters.data.accountAds,
      };

      getLeadsReport(params)
        .then((result) => {
          this.stats = result.stats;

          this.chartDataPolar = result.bar_line;
          this.chartDataPolarMKT = result.bar_line_mkt;

          // format graph
          this.chartDataLine.data.labels = result.graph_day.labels;

          let auxDataset = [];

          result.graph_day.data.forEach((d) => {
            auxDataset.push({
              label: d.label,
              data: d.data,
            });
          });

          this.chartDataLine.data.datasets = auxDataset;

          // format graph
          this.chartDataHour.data.labels = result.graph_hour.labels;
          
          let auxDataSetHour = [];

          result.graph_hour.data.forEach((d) => {
            auxDataSetHour.push({
              label: d.label,
              data: d.data,
            });
          });

          this.chartDataHour.data.datasets = auxDataSetHour;
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }

          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao buscar dados",
          });
        })
        .finally(() => {
          this.loading = false;
          this.data = emptyData;
        });
    },
    getTrackings() {
      this.loading = true;

      const date = this.filters.data.date;
      let params = {
        start_date: date[0] ? date[0].toISOString().slice(0, 10) : "",
        end_date: date[1] ? date[1].toISOString().slice(0, 10) : "",
        group_by: this.filters.data.group_by,
        search: this.filters.data.search,
        page: this.page,
        offset: this.offset,
      };
      getTrackingsLead(params)
        .then((result) => {
          this.trackings = result.trackings.map((p) => {
            return {
              name: p.name,
              group_by: p.group_by,
              stats: {
                leads: p.stats.leads,
                pageview: p.stats.pageview,
                spend: p.stats.spend,
                conv: p.stats.conv,
                cost_lead: p.stats.cost_lead,
              },
            };
          });

          // utms
          this.UTMS = result.utms;

          this.totalTracking = result.total;

          // this.stats = result.stats;
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao buscar tracking",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
#dash-profit {
  background: var(--bg);
}

.filters-group-holder {
  position: sticky;
  top: -1px;
  z-index: 4;

  &[stuck] {
    background: var(--bg);
    padding: 35px 5px 15px 5px;
  }
}

.custom-card {
  min-width: 250px;
  position: relative;
  .big-icon {
    i {
      color: var(--primary);
      
      font-size: 28px;
    }
  }
  .title {
    white-space: nowrap;
  }
  .info {
    position: absolute;
    right: 4px;
    top: 4px;
    font-size: 16px;
  }
  h3 {
    font-size: 22px;
    white-space: nowrap;
  }
  h1 {
    font-size: 32px;
    color: var(--primary);
  }

  &.negative {
    h1 {
      color: #fff !important;
    }
  }
}
.primary-bg {
  background: #fff;

  h1 {
    color: var(--terciary);
  }

  span {
    color: var(--terciary);

  }
}

.primary-bg {
  .source-data{
    h3 {
      // color: var(--terciary);
      color: var(--terciary);

      font-weight: 400;
    }
  }
}

.source-data {
  h3 {
    color: var(--text2);
    font-weight: 400;
  }
}

li {
  list-style-type: none;
  padding-bottom: 8px;
  padding-top: 8px;
  border-bottom: 1px solid #e6e4e4;
  padding-left: 8px;
  
}

.red {
    color: red;
  }
.gren {
    color: green;
}

.max-table {
  overflow-y: scroll;
  max-height: 400px;
  padding-bottom: 16px;
}

</style>
